"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProducts = void 0;
const get_products_stream_1 = require("./get-products-stream");
const routes_1 = require("../../routes");
const stream_1 = require("../../stream");
const getProducts = (client) => async (query) => {
    if (!query?.limit && !query?.page && query?.is_indexable) {
        return (0, stream_1.unwrapStream)(await (0, get_products_stream_1.getProductsStreamResponse)(client)(query));
    }
    const response = await client.get(routes_1.ENDPOINTS.GET_PRODUCTS.path, { params: query });
    return response.data;
};
exports.getProducts = getProducts;
